var jalaali = require('jalaali-js')

export const _getFieldError = (form, field) => {
  if (form.errors[field] && form.touched[field]) {
    return {
      type: 'error',
      rightComponent: form.errors[field],
    }
  }
}

export const _getFieldStatus = (form, field) => {
  if (form.touched[field]) {
    if (form.errors[field]) {
      return 'error'
    } else {
      return 'ok'
    }
  }
}

export const _minTwoDigits = (num) => {
  return ('0' + num).slice(-2)
}

export const _isNumeric = (val) => {
  return !isNaN(val)
}

export const _getNMinutesLater = (n) => {
  const time = new Date()
  time.setMinutes(time.getMinutes() + n)
  return time
}

export const _queryToUrlParams = (query) => {
  let params = ''

  Object.keys(query).forEach(
    (key, index) =>
      query[key] &&
      (index == 0
        ? (params += `?${key}=${query[key]}`)
        : (params += `&${key}=${query[key]}`)),
  )

  return params
}

export const _getDateText = (date, year_included) => {
  const _date = new Date(date)
  const _persianDate = jalaali.toJalaali(_date)

  let _month = ''

  switch (_persianDate.jm) {
    case 1:
      _month = 'فروردین'
      break
    case 2:
      _month = 'اردیبهشت'
      break
    case 3:
      _month = 'خرداد'
      break
    case 4:
      _month = 'تیر'
      break
    case 5:
      _month = 'مرداد'
      break
    case 6:
      _month = 'شهریور'
      break
    case 7:
      _month = 'مهر'
      break
    case 8:
      _month = 'آبان'
      break
    case 9:
      _month = 'آذر'
      break
    case 10:
      _month = 'دی'
      break
    case 11:
      _month = 'بهمن'
      break
    case 12:
      _month = 'اسفند'
      break
    default:
      break
  }

  return `${_persianDate.jd} ${_month}${
    year_included ? ` ${_persianDate.jy}` : ''
  }`
}

export const getUserChannelId = (channel) => {
  return channel == 'B2B'
    ? process.env.REACT_APP_B2B_CHANNEL_ID
    : process.env.REACT_APP_B2C_CHANNEL_ID
}

export const handlePersianInput = (value) => {
  const persianRegex = /^[\u0600-\u06FF0-9\s]*$/;
  if (persianRegex.test(value)) {
    return value;
  }
  return value.replace(/[^\u0600-\u06FF0-9\s]/g, "");
};